import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTechnicians, deleteTechnician } from '../features/technicianSlice';
import AddTechnicianModal from './AddTechnicianModal';
import CommanTable from './CommanTable';
import '../styles/technicianList.css';
import locationIcon from '../assets/images/location_icon.svg';
import editIcon from '../assets/images/Edit.svg'; // ReplaceP with correct edit icon if available
import deleteIcon from '../assets/images/Delete.svg'; // Replace with correct delete icon if available
import searchIcon from '../assets/images/search.svg';
import Pagination from './Pagination';
import { getTimeAgo } from '../utils/dateUtils';
import { debounce } from '../utils/debounce';
import Loader from '../utils/globalApiLoader';

import DeleteTechnicianModal from './DeleteTechnicianModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';





const TechnicianList = ({ modalOpen, setModalOpen }) => {
  const [search, setSearch] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null);
  const dispatch = useDispatch();
  const loading = useSelector(state => state.technicians?.loading);

  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [order, setOrder] = useState('DESC');


  // Debounced fetch for search and sort
  const debouncedFetch = React.useRef(
    debounce((fetchPage, searchValue, sortField, sortOrder) => {
      dispatch(fetchTechnicians({ role: 'TECHNICIAN', page: fetchPage, size, searchBy: searchValue, sortBy: sortField, order: sortOrder }))
        .then(data => {
          const payload = data?.payload || {};
          setUsers(payload.users || []);
          setTotal(payload.total || 0);
          setSize(payload.pageSize || 10);
        });
    }, 400)
  ).current;

  useEffect(() => {
    setSize(10); // Reset size to 10 when component mounts
    // If search changes, reset page to 1
    if (page !== 1 && search !== '') {
      setPage(1);
      debouncedFetch(1, search, sortBy, order);
    } else {
      debouncedFetch(page, search, sortBy, order);
    }
    // eslint-disable-next-line
  }, [dispatch, page, size, search, sortBy, order]);


  // Handler for edit icon
  const handleEditClick = (e, user) => {
    e.stopPropagation();
    setEditMode(true);
    setSelectedUser(user);
    setModalOpen(true);
  };

  // Handler for sort icon click
  const handleSort = (field) => {
    let backendField = field;
    if (field === 'name') backendField = 'firstname';
    if (sortBy === backendField) {
      setOrder((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
    } else {
      setOrder('ASC');
    }
    setSortBy(backendField);
  };

  const handleModalClose = (actionType) => {
    setModalOpen(false);
    setSelectedUser(null);
    setEditMode(false);
    if (actionType === 'add') {
      toast.success('Technician created successfully');
      setPage(1);
      dispatch(fetchTechnicians({ role: 'TECHNICIAN', page: 1, size, search, sortBy, order }))
        .then(data => {
          const payload = data?.payload || {};
          setUsers(payload.users || []);
          setTotal(payload.total || 0);
          setSize(payload.pageSize || 10);
        });
    } else if (actionType === 'update') {
      toast.success('Technician updated successfully');
      dispatch(fetchTechnicians({ role: 'TECHNICIAN', page: 1, size, search, sortBy, order }))
        .then(data => {
          const payload = data?.payload || {};
          setUsers(payload.users || []);
          setTotal(payload.total || 0);
          setSize(payload.pageSize || 10);
        });
    }
  };

  const handleDeleteClick = (e, user) => {
    e.stopPropagation();
    setDeleteUser(user);
    setDeleteModalOpen(true);
  };

  // const handleDeleteModalClose = () => {
  //   setDeleteModalOpen(false);
  //   setDeleteUser(null);
  // };

  // const handleDelete = () => {
  //   // TODO: Call delete API here
  //   setDeleteModalOpen(false);
  //   setDeleteUser(null);
  // };





  const totalPages = Math.ceil(total / size);

  // Handler for deleting a technician
  const handleDelete = async () => {
    if (deleteUser && deleteUser.id) {
      const result = await dispatch(deleteTechnician(deleteUser.id));
      setDeleteModalOpen(false);
      setDeleteUser(null);
      if (!deleteTechnician.rejected.match(result)) {
        // Refresh list after successful delete
        dispatch(fetchTechnicians({ role: 'TECHNICIAN', page: 1, size, search, sortBy, order }))
          .then(data => {
            const payload = data?.payload || {};
            setUsers(payload.users || []);
            setTotal(payload.total || 0);
            setSize(payload.pageSize || 10);
          });
        toast.success('Technician deleted successfully');
      }
    }
  };

  return (
    <>
      <div className='technician-list'>
        <div className="technician-wrapper">

          <div className='search-filter'>
            <div className='input-card'>
              <input
                className="dashboard-table-search"
                placeholder="Search by :- Technician, Location, or Contact Number"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <button><img src={searchIcon} alt="Search" /></button>
            </div>
          </div>

          {/* <input
          className="dashboard-table-search"
          placeholder="Search  by Status, Location"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <span className="dashboard-table-search-icon">
          <img src={searchIcon} alt="Search" style={{ width: 20, height: 20, verticalAlign: 'middle' }} />
        </span> */}
          <div className='device-list'>
            {loading ? (
              // <div style={{ padding: '24px', textAlign: 'center' }}>
              //   Loading Technicians...
              // </div>
              <Loader />
            ) : (
              <>
                <div className="device-list-table table-responsive">
                  <CommanTable
                    columns={[
                      { key: 'name', label: 'Name', sortable: true },
                      { key: 'email', label: 'Email', sortable: true },
                      { key: 'phone', label: 'Phone', sortable: true },
                      { key: 'city', label: 'City', sortable: true },
                      { key: 'lastLogged', label: 'Last Active', sortable: true },
                    ]}
                    data={users.map(tech => ({
                      id: tech.id,
                      name: (tech.firstname || '') + (tech.lastname ? ' ' + tech.lastname : '') || tech.name || '',
                      email: tech.email,
                      phone: tech.phone,
                      city: (
                        <span><img src={locationIcon} alt="location" style={{ width: 11, height: 15, marginRight: 4, verticalAlign: 'middle' }} />{tech?.city?.name}</span>
                      ),
                      lastLogged: tech.lastLogged ? getTimeAgo(tech.lastLogged) : " -",
                    }))}
                    onSort={handleSort}
                    sortBy={sortBy}
                    actions={row => (
                      <>
                        <span style={{ marginRight: 12, cursor: 'pointer' }} title="Edit" onClick={e => handleEditClick(e, users.find(u => u.id === row.id))}>
                          <img src={editIcon} alt="edit" style={{ width: 16, height: 16, filter: 'brightness(0) saturate(100%) invert(25%) sepia(8%) saturate(522%) hue-rotate(109deg) brightness(93%) contrast(89%)' }} />
                        </span>
                        <span style={{ cursor: 'pointer' }} title="Delete" onClick={e => handleDeleteClick(e, users.find(u => u.id === row.id))}>
                          <img src={deleteIcon} alt="delete" style={{ width: 16, height: 16, filter: 'brightness(0) saturate(100%) invert(14%) sepia(88%) saturate(3374%) hue-rotate(331deg) brightness(108%) contrast(96%)' }} />
                        </span>
                      </>
                    )}
                  />
                </div>
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  totalResults={total}
                  limit={size}
                  onPageChange={p => {
                    setPage(p);
                    debouncedFetch(p, search, sortBy, order);
                  }}
                />
              </>
            )}
          </div>
          {modalOpen &&
            <AddTechnicianModal
              open={modalOpen}
              editMode={editMode}
              onClose={handleModalClose}
              user={selectedUser}
            />
          }
          {deleteModalOpen &&
            <DeleteTechnicianModal
              open={deleteModalOpen}
              onClose={() => { setDeleteModalOpen(false); setDeleteUser(null); }}
              onDelete={handleDelete}
            />
          }

        </div >
      </div>
    </>
  );
};


export default TechnicianList;
